export default __webpack_public_path__ + "static/media/ID.6b1bf1ca.svg";